import { createBrowserRouter, Navigate } from 'react-router-dom';
import { getItem } from '../utils/utils';
import { accessTokenKey } from '../utils/constants';
import {
  BASEPATH,
  BOOKINGSPATH,
  EVENTMANAGEMENTPATH,
  EVENTCREATIONPATH,
  FACILITYMANAGEMENTPATH,
  LOGINPATH,
  SPORTSMANAGEMENTPATH,
  TRANSACTIONSPATH,
  USERMANAGEMENTPATH,
  DOUBLESPLAYERDETAILSPATH,
  DOUBLESBRACKETSPATH,
  SINGLESBRACKETSPATH,
  SINGLESGENERATEBRACKETPATH,
  TEAMSPLAYERSDETAILSPATH,
  MATCHSCOREPATH,
} from './routePaths';
import Login from '../pages/Login';
import AppLayout from '../components/layout/AppLayout';
import Facility from '../pages/Facility';
import Events from '../pages/Events';
import EventCreation from '../components/features/Events/EventCreation';
import Bookings from '../pages/Bookings';
import UserManagement from '../pages/UserManagement';
import UserDetailsView from '../components/features/User/UserDetails';
import FacilityDetailView from '../components/features/FacilityDetailView/FacilityDetailView';
import SportsManagement from '../pages/SportsManagement';
import Transactions from '../pages/Transactions';
import DoublesBrackets from '../components/features/Events/DoublesBrackets';
import DoublesPlayersDetails from '../components/features/Events/DoublesPlayersDetails';
import EventDetailsLayout from '../components/layout/EventDetailsLayout';
import SinglesGenerateBracketScreen from '../components/features/Events/SinglesGenerateBracketScreen';
import EventDetailsScreen from '../components/features/Events/EventDetailsScreen';
import SinglesBrackets from '../components/features/Events/SinglesBrackets';
import TeamsPlayersDetails from '../components/features/Events/TeamsPlayersDetails';
import MatchScoreScreen from '../components/features/Events/MatchScoreScreen';

const AuthWrapper = () => {
  const token = getItem(accessTokenKey);
  if (!token) return <Navigate to={LOGINPATH} replace />;
  return <AppLayout />;
};

const router = createBrowserRouter([
  { path: LOGINPATH, element: <Login /> },
  {
    path: BASEPATH,
    element: <AuthWrapper />,
    children: [
      { index: true, element: <Navigate to={USERMANAGEMENTPATH} replace /> },
      {
        path: USERMANAGEMENTPATH,
        element: <UserManagement />,
        children: [{ path: ':userId', element: <UserDetailsView /> }],
      },
      {
        path: FACILITYMANAGEMENTPATH,
        element: <Facility />,
        children: [{ path: ':facilityId', element: <FacilityDetailView /> }],
      },
      { path: BOOKINGSPATH, element: <Bookings /> },
      { path: TRANSACTIONSPATH, element: <Transactions /> },
      {
        path: EVENTMANAGEMENTPATH,
        element: <Events />,
      },
      {
        path: `${EVENTMANAGEMENTPATH}/:eventId`,
        element: <EventDetailsLayout />,
        children: [
          { index: true, element: <EventDetailsScreen /> },
          {
            path: `${DOUBLESPLAYERDETAILSPATH}`,
            element: <DoublesPlayersDetails />,
          },
          {
            path: `${DOUBLESBRACKETSPATH}`,
            element: <DoublesBrackets />,
          },
          {
            path: `${SINGLESGENERATEBRACKETPATH}`,
            element: <SinglesGenerateBracketScreen />,
          },
          {
            path: `${SINGLESBRACKETSPATH}`,
            element: <SinglesBrackets />,
          },
          {
            path: `${TEAMSPLAYERSDETAILSPATH}`,
            element: <TeamsPlayersDetails />,
          },
          {
            path: `${MATCHSCOREPATH}`,
            element: <MatchScoreScreen />,
          },
        ],
      },
      { path: EVENTCREATIONPATH, element: <EventCreation /> },
      { path: SPORTSMANAGEMENTPATH, element: <SportsManagement /> },
    ],
  },
  {
    path: '*',
    element: <Navigate to={USERMANAGEMENTPATH} replace />,
  },
]);

export default router;
